<template>
  <div class="row row-inside">
    <div class="flex md4">
      <va-card title="Entreprise">
        <div class="row row-inside">
          <div class="flex md3"></div>
          <div class="flex md3"><b>Mois</b></div>
          <div class="flex md3"><b>Mois dernier</b></div>
          <div class="flex md3"><b>Tout temps</b></div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Création</b></div>
          <div class="flex md3">{{ getStats(1, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(1, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(1, statsUser) }}</div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Modification</b></div>
          <div class="flex md3">{{ getStats(2, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(2, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(2, statsUser) }}</div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Suppression</b></div>
          <div class="flex md3">{{ getStats(16, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(16, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(16, statsUser) }}</div>
        </div>
      </va-card>
    </div>
    <div class="flex md4">
      <va-card title="Contact">
        <div class="row row-inside">
          <div class="flex md3"></div>
          <div class="flex md3"><b>Mois</b></div>
          <div class="flex md3"><b>Mois dernier</b></div>
          <div class="flex md3"><b>Tout temps</b></div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Création</b></div>
          <div class="flex md3">{{ getStats(5, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(5, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(5, statsUser) }}</div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Modification</b></div>
          <div class="flex md3">{{ getStats(7, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(7, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(7, statsUser) }}</div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Suppression</b></div>
          <div class="flex md3">{{ getStats(18, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(18, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(18, statsUser) }}</div>
        </div>
      </va-card>
    </div>
    <div class="flex md4">
      <va-card title="Etablissement">
        <div class="row row-inside">
          <div class="flex md3"></div>
          <div class="flex md3"><b>Mois</b></div>
          <div class="flex md3"><b>Mois dernier</b></div>
          <div class="flex md3"><b>Tout temps</b></div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Création</b></div>
          <div class="flex md3">{{ getStats(14, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(14, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(14, statsUser) }}</div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Modification</b></div>
          <div class="flex md3">{{ getStats(15, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(15, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(15, statsUser) }}</div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Suppression</b></div>
          <div class="flex md3">{{ getStats(17, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(17, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(17, statsUser) }}</div>
        </div>
      </va-card>
    </div>
    <div class="flex md4">
      <va-card title="Partenaire">
        <div class="row row-inside">
          <div class="flex md3"></div>
          <div class="flex md3"><b>Mois</b></div>
          <div class="flex md3"><b>Mois dernier</b></div>
          <div class="flex md3"><b>Tout temps</b></div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Création</b></div>
          <div class="flex md3">{{ getStats(3, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(3, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(3, statsUser) }}</div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Modification</b></div>
          <div class="flex md3">{{ getStats(4, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(4, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(4, statsUser) }}</div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Suppression</b></div>
          <div class="flex md3">{{ getStats(20, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(20, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(20, statsUser) }}</div>
        </div>
      </va-card>
    </div>
    <div class="flex md4">
      <va-card title="Contact Partenaire">
        <div class="row row-inside">
          <div class="flex md3"></div>
          <div class="flex md3"><b>Mois</b></div>
          <div class="flex md3"><b>Mois dernier</b></div>
          <div class="flex md3"><b>Tout temps</b></div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Création</b></div>
          <div class="flex md3">{{ getStats(6, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(6, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(6, statsUser) }}</div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Modification</b></div>
          <div class="flex md3">{{ getStats(8, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(8, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(8, statsUser) }}</div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Suppression</b></div>
          <div class="flex md3">{{ getStats(21, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(21, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(21, statsUser) }}</div>
        </div>
      </va-card>
    </div>
    <div class="flex md4">
      <va-card title="Autre">
        <div class="row row-inside">
          <div class="flex md3"></div>
          <div class="flex md3"><b>Mois</b></div>
          <div class="flex md3"><b>Mois dernier</b></div>
          <div class="flex md3"><b>Tout temps</b></div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Journal</b></div>
          <div class="flex md3">{{ getStats(9, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(9, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(9, statsUser) }}</div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Prélèvement</b></div>
          <div class="flex md3">{{ getStats(11, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(11, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(11, statsUser) }}</div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Adhésions</b></div>
          <div class="flex md3">
            {{
              getStats(12, statsUserMonth) +
              getStats(13, statsUserMonth) +
              getStats(19, statsUserMonth)
            }}
          </div>
          <div class="flex md3">
            {{
              getStats(12, statsUserLastMonth) +
              getStats(13, statsUserLastMonth) +
              getStats(19, statsUserLastMonth)
            }}
          </div>
          <div class="flex md3">
            {{
              getStats(12, statsUser) +
              getStats(13, statsUser) +
              getStats(19, statsUser)
            }}
          </div>
        </div>
        <div class="row row-inside">
          <div class="flex md3"><b>Campagne</b></div>
          <div class="flex md3">{{ getStats(10, statsUserMonth) }}</div>
          <div class="flex md3">{{ getStats(10, statsUserLastMonth) }}</div>
          <div class="flex md3">{{ getStats(10, statsUser) }}</div>
        </div>
      </va-card>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { countBy, map } from "lodash";
import moment from "moment";
export default {
  name: "users",
  data() {
    return {
      statsUser: [],
      statsUserMonth: [],
      statsUserLastMonth: [],
      startMonth: moment().startOf("month"),
      startLastMonth: moment().subtract(1, "months").startOf("month"),
    };
  },
  created() {
    this.loadStats();
  },
  methods: {
    async loadStats() {
      let res = await axios.get("/api/user-stats");
      this.statsUser = res.data;
      this.statsUserMonth = res.data.filter((element) => {
        return moment(element.date_action).isSameOrAfter(this.startMonth);
      });
      this.statsUserLastMonth = res.data.filter((element) => {
        return (
          moment(element.date_action).isBefore(this.startMonth) &&
          moment(element.date_action).isSameOrAfter(this.startLastMonth)
        );
      });
    },
    getStats(id, statsList) {
      return statsList.filter((element) => {
        return element.iduser_action_types === id;
      }).length;
    },
  },
};
</script>

<style lang="scss"></style>
